import { render } from "./TheCoSoYTeTuNhan.vue?vue&type=template&id=f198a302"
import script from "./TheCoSoYTeTuNhan.vue?vue&type=script&lang=js"
export * from "./TheCoSoYTeTuNhan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__